import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { MobileHeaderComponent } from '../../components/mobile-header/mobile-header.component';

@Component({
  selector: 'app-compass-ad',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, SidebarComponent, MobileHeaderComponent],
  templateUrl: './compass-ad.component.html',
  styleUrl: './compass-ad.component.scss'
})
export class CompassAdComponent {

  actual_step: number = 1;
  link_output: string = '';
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private translate: TranslateService) {

    // Suscribirse a cambios en la URL utilizando el Router de Angular
    this.router.events.subscribe((event: any) => {
      // Importar NavigationEnd desde @angular/router si se desea filtrar solo cuando cambia la url
      if (event instanceof NavigationEnd) {
          // Set the actual step based on the current URL
          const url = event.urlAfterRedirects;
          if (url.includes('select-plan')) {
            this.actual_step = 1;
          } else if (url.includes('register')) {
            this.actual_step = 2;
          } else if (url.includes('payment')) {
            this.actual_step = 3;
          }
      }
      else{
        const url = event.routerEvent.url;
        if (url.includes('select-plan')) {
          this.actual_step = 1;
        } else if (url.includes('register')) {
          this.actual_step = 2;
        } else if (url.includes('payment')) {
          this.actual_step = 3;
        }
      }
    });

    // we set the language from the parameters coming from the url
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params['lang']) {
        this.translate.use(params['lang']);
        localStorage.setItem('language_conectio_client', params['lang']);
      }
    });
  }
  data_progress: any = [{
      id: 1,
      title: 'compassAd.plan.title',
      route: 'select-plan',
    }, 
    {
      id: 2,
      title: 'compassAd.register.title',
      route: 'register',
    },
    {
      id: 3,
      title: 'compassAd.payment.title',
      route: 'payment',
    },
  ]

  ngOnInit() {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.link_output = navigation.extras.state['link'];
      console.log('Link output from ad:', this.link_output);
    }


}

goToStep(route: string, id: number) {

  if (id <= this.actual_step) {
    this.router.navigate(["compass/buy/" + route]);
    this.actual_step = id;
  }
}

}
